import React, { useEffect, useRef, useState } from 'react';
import "./faq.css";
import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from "reactstrap";
import bgVideo from "./faqpagevideo.mp4";
import bgVideoM from "./faqpagevideomobile.mp4";
import { useLanguage } from '../../context/LanguageContext';

const FaqPage = () => {
    const { t, changeLanguage } = useLanguage();
    const topRef = useRef();
    const bottomRef = useRef();
    const [isTopVisible, setIsTopVisible] = useState(false);
    const [isBottomVisible, setIsBottomVisible] = useState(false);


    useEffect(() => {
        const topObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setIsTopVisible(true);
                    topObserver.unobserve(entry.target);
                }
            });
        });

        const bottomObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setIsBottomVisible(true);
                    bottomObserver.unobserve(entry.target);
                }
            });
        });

        if (topRef.current) {
            topObserver.observe(topRef.current);
        }

        if (bottomRef.current) {
            bottomObserver.observe(bottomRef.current);
        }

        return () => {
            if (topRef.current) {
                topObserver.unobserve(topRef.current);
            }
            if (bottomRef.current) {
                bottomObserver.unobserve(bottomRef.current);
            }
        };
    }, []);

    const [open, setOpen] = useState("1");
    const toggle = (id) => {
        if (open === id) {
            setOpen(null); // veya setOpen('');
        } else {
            setOpen(id);
        }
    };

    const ref = useRef();
    const [isVisible, setIsVisible] = useState(false);

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                setIsVisible(true);
                observer.unobserve(entry.target);
            }
        });
    });

    return (
        <div className="faq-page-container">

            <div className={`faq-page-top-container ${isTopVisible ? 'fade-in' : ''}`} ref={topRef}>

                <div class="faq-page-video-container faq-video-web">
                    <video class="faqpage-video" src={bgVideo} autoPlay muted loop playsInline></video>
                </div>

                <div class="faq-page-video-container faq-video-mobile md:hidden">
                    <video class="faqpage-video" src={bgVideoM} autoPlay muted loop playsInline></video>
                </div>

                <h1 className="faq-page-title1 mb-8">{t("faq-title")}</h1>

            </div>

            <div className={`faq-page-bottom-container text-left ${isBottomVisible ? 'fade-in' : ''}`} ref={bottomRef}>

                {/* <h1 className='faq-title2'>
                        PDI ile ilgili merak edilen sorular:
                    </h1> */}
                <div className='mt-8'>
                    <Accordion open={open} toggle={toggle}>
                        <AccordionItem>
                            <AccordionHeader targetId="soru1">{t('faq-question-1')}</AccordionHeader>
                            <AccordionBody accordionId="soru1">{t('faq-answer-1')}</AccordionBody>
                        </AccordionItem>

                        <AccordionItem>
                            <AccordionHeader targetId="soru2">{t('faq-question-2')}</AccordionHeader>
                            <AccordionBody accordionId="soru2">{t('faq-answer-2')}</AccordionBody>
                        </AccordionItem>

                        <AccordionItem>
                            <AccordionHeader targetId="soru3">{t('faq-question-3')}</AccordionHeader>
                            <AccordionBody accordionId="soru3">{t('faq-answer-3')}</AccordionBody>
                        </AccordionItem>

                        <AccordionItem>
                            <AccordionHeader targetId="soru4">{t('faq-question-4')}</AccordionHeader>
                            <AccordionBody accordionId="soru4">{t('faq-answer-4')}</AccordionBody>
                        </AccordionItem>

                        <AccordionItem>
                            <AccordionHeader targetId="soru5">{t('faq-question-5')}</AccordionHeader>
                            <AccordionBody accordionId="soru5">{t('faq-answer-5')}</AccordionBody>
                        </AccordionItem>

                        <AccordionItem>
                            <AccordionHeader targetId="soru6">{t('faq-question-6')}</AccordionHeader>
                            <AccordionBody accordionId="soru6">{t('faq-answer-6')}</AccordionBody>
                        </AccordionItem>

                        <AccordionItem>
                            <AccordionHeader targetId="soru7">{t('faq-question-7')}</AccordionHeader>
                            <AccordionBody accordionId="soru7">{t('faq-answer-7')}</AccordionBody>
                        </AccordionItem>

                        <AccordionItem>
                            <AccordionHeader targetId="soru8">{t('faq-question-8')}</AccordionHeader>
                            <AccordionBody accordionId="soru8">{t('faq-answer-8')}</AccordionBody>
                        </AccordionItem>

                        <AccordionItem>
                            <AccordionHeader targetId="soru9">{t('faq-question-9')}</AccordionHeader>
                            <AccordionBody accordionId="soru9">{t('faq-answer-9')}</AccordionBody>
                        </AccordionItem>

                        <AccordionItem>
                            <AccordionHeader targetId="soru10">{t('faq-question-10')}</AccordionHeader>
                            <AccordionBody accordionId="soru10">{t('faq-answer-10')}</AccordionBody>
                        </AccordionItem>
                    </Accordion>
                </div>
            </div>

        </div>



    )
}

export default FaqPage